import * as THREE from "three"
import Stats from "three/examples/jsm/libs/stats.module"
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
// import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module"
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader"

import * as CANNON from "cannon-es"
import CannonDebugger from "cannon-es-debugger"
// import {
//   geometryToShape,
//   bodyToMesh,
// } from "../components/three-conversion-utils"

import {
    EffectComposer,
    RenderPass,
    EffectPass,
    ToneMappingEffect,
    ToneMappingMode,
    // NoiseEffect,
    BloomEffect,
    SMAAEffect,
    // DepthOfFieldEffect,
} from "postprocessing"

import { gsap } from "gsap"


//

import {
    isM,
    getRealSize,
    realLoader,
    randomNum,
    LOCAL_,
} from "../components/alpha"

// import { values } from "../components/values"
// import * as mat from "../components/materials"
import { defPath, fetchPath } from "../config/defPath"

import { SoundController } from "../classes/soundController"
import { CameraController } from "../classes/cameraController"
import { Avatar } from "../classes/avatar"
import { NPC } from "../classes/npc"
import { Estadio } from "../classes/estadium"
// import { Joystick } from "../classes/joystick"
// import { CharacterController } from "../classes/characterController"


//

import { PopsController } from "../classes/popsController"
import { VideoController } from "../classes/videoController"
// import { QuestionsController } from "../classes/questionsController"
import { Collectables } from "../classes/collectables"

import { useSession } from "../hooks/useState"
import { Gift } from "../classes/gift"


//
// INIT ----------------------------------------------------------------------

const devRot = document.querySelector("#deviceRotated")
isM ? devRot.classList.add("mobile") : devRot.remove()

//

let sigla = "Brzkr"
let clock, scene, renderer, composer
let world, cannonDebugger

const GLTF_loader = new GLTFLoader()
const Env_loader = new RGBELoader()
// const textureLoader = new THREE.TextureLoader()

const appContainer = document.querySelector("#king-home")
const canvas = document.querySelector("#canvas-home")

// console.log("Local?", LOCAL_)
let stats = LOCAL_ ? true : false
let cannonDebug = LOCAL_ ? true : false

//
// Load control ----------------------------------------------------------------
const loadControl = {
    value: 0,
    finish: false,
    allowLogSize: false,
    elements: {},
}
window.loadControl = loadControl


// ---------------------------------------------------------------------------

const init = async () => {

    // console.log(`[${sigla}] Estadio init`)

    // if (!localStorage.getItem('ageGateValidate') && !location.port) return

    let size = getRealSize(appContainer)

    // ---------------------------------------------------------------------------

    clock = new THREE.Clock()

    scene = new THREE.Scene()
    window.scene = scene

    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        // antialias: true,
        // ----Postprocessing
        powerPreference: "high-performance",
        antialias: false,
        stencil: false,
        depth: false,
        alpha: true,
    })
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    renderer.setSize(size.w, size.h)
    renderer.setClearColor(0x00ff00, 0)
    renderer.physicallyCorrectLights = true
    renderer.outputEncoding = THREE.sRGBEncoding

    renderer.shadowMap.enabled = true
    // renderer.shadowMap.type = THREE.VSMShadowMap // THREE.PCFSoftShadowMap // 
    renderer.shadowMap.bias = 0.01
    renderer.shadowMap.width = 256
    renderer.shadowMap.height = 256


    // scene.add( new THREE.AmbientLight(0xffffff, 1.5) )

    const light = new THREE.DirectionalLight(0xffffff, 2)

    light.userData = { x: -7, y: 18, z: 2 } // Position
    const lud = light.userData

    light.position.set(lud.x, lud.y, lud.z)

    scene.add(light)

    light.castShadow = true;
    light.shadow.bias = -0.005
    // light.shadow.mapSize.width = 1024;
    // light.shadow.mapSize.height = 1024;
    light.shadow.camera.near = 0.5;
    light.shadow.camera.far = 250;
    light.shadow.camera.left = -35;
    light.shadow.camera.right = 35;
    light.shadow.camera.top = 35;
    light.shadow.camera.bottom = -35;

    window.testLight = light

    // const shadowHelper = new THREE.CameraHelper(light.shadow.camera);
    // scene.add(shadowHelper);


    //
    // Physics ------------------------------------------------------------------------

    world = new CANNON.World({
        gravity: new CANNON.Vec3(0, -9.81, 0),
    })
    // world.broadphase = new CANNON.GridBroadphase(world)
    world.allowSleep = true
    window.world = world

    cannonDebugger = new CannonDebugger(scene, world, {})

    // const avatarMat = new CANNON.Material("Avatar")
    // const floorMat = new CANNON.Material("Floor")
    // const avatarFloorCMat = new CANNON.ContactMaterial(avatarMat, floorMat, {
    //     friction: 0.01, restitution: 0,
    // })
    // world.addContactMaterial(avatarFloorCMat)

    const floorBody = new CANNON.Body({
        shape: new CANNON.Plane(),
        type: CANNON.Body.STATIC,
    })
    floorBody.quaternion.setFromEuler(-Math.PI * 0.5, 0, 0, "XYZ")
    floorBody.position.set(0, 0, 0)

    world.addBody(floorBody)


    // Extras -----
    if (LOCAL_) scene.add(new THREE.AxesHelper(10))

    if (stats) {
        stats = new Stats()
        stats.dom.style.cssText = 'top: 30% position: fixed z-index: 999999'
        document.body.appendChild(stats.dom)
    }



    //
    // EnvMap ------------------------------------------------------------------

    const envObj = "dancing"
    Env_loader
        .load(`${defPath}/assets/glb/envMap/${envObj}.hdr`,
            (hdri) => {
                hdri.mapping = THREE.EquirectangularReflectionMapping
                scene.environment = hdri
            },
            (xhr) => {
                loadControl.elements.envMap = { loaded: xhr.loaded, total: xhr.total }
                if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`[${sigla}] EnvMap "${envObj}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
            },
            (error) => {
                console.warn(`[${sigla}] EnvMap: Error loading`)
                // console.warn( error )
            }
        )


    // GLTF ------------------------------------------------------------------
    // gltfpack -c -vt 14 -vn 10 -kn -i ./dist/assets/glb/01.glb -o ./dist/assets/glb/01c.glb

    // APP ------------------------------------------------------------------

    const cameraController = new CameraController({ DOMelem: appContainer })
    window.cameraController = cameraController

    const soundController = new SoundController(cameraController.camera)
    window.soundController = soundController
    soundController.load([
        'loop_bg',
        'sections',
        // 'passion',
        'questions',
        'collectable',
        'gift',
        'clic',
        'cerrar'
    ])

    const avatar = new Avatar()
    window.avatar = avatar
    avatar.loadModel('Hombre')
    avatar.loadModel('Mujer')

    const estadio = new Estadio()
    estadio.loadEstadio('estadio_v32a')

    const collectables = new Collectables()
    window.collectables = collectables
    collectables.loadCollectables()

    const gift = new Gift()
    gift.create()

    const npc = new NPC()
    npc.loadNPCs([
        'Rubigol_litec',
        'Camc',
        'Repc',
        'Arbitro_01c',
        'Arbitro_02c',
        'Arbitro_03c',
        'Fotografoc',
        'RP_01c',
        'RP_02c',
        'RP_03c',
    ])
    window.npc = npc


    //
    // Init sound in first clic
    function firstClic() {

        // Init sound
        soundController.init()
        soundController.play('loop_bg', true, 0.1)

        window.removeEventListener('pointerup', firstClic)
    }
    window.addEventListener('pointerup', firstClic)


    //
    // const sessionFetch = fetch(`${fetchPath}/aguila/loyalty/validate/session`, { method: "POST" })
    // console.log('estadio - endpoint session: ', sessionFetch)

    async function initAguila() {

        const responseLocal = {
            logged: false,
            user: {
                name: 'Luis',
                lastname: 'Diaz',
                coins: '165',
                redeemable: ['Sup_camisa_101_p-100'],
                json_avatar: {
                    genero: 'Hombre',
                    piel: 'B',
                    cabello: { type: '03', color: '002D6E' },
                    barba: { type: '02', color: '000000' },
                    Sup: { type: 'camiseta', code: '01' },
                    Inf: { type: 'pant-corta', code: '01' },
                    medias: { code: '01' },
                    Cal: { type: 'guayos', code: '01' },
                    Acc: [
                        { type: 'guantes', code: '01' },
                        // {type: 'sombrero-01', code: '01'},
                        { type: 'gafas-01' }
                    ],
                },
            },
        }

        // if (window.drupalSettings && window.drupalSettings.user.uid !== 0){
        //     if (LOCAL_) {
        //         avatar.setJSON(responseLocal.user.json_avatar)
        //     } else {
        //         const userData = useSession.getState().user.json_avatar
        //         avatar.setJSON(userData)
        //     }
        // } else {
        //     avatar.setJSON(responseLocal.user.json_avatar)
        // }
        

        const userLogged = window.drupalSettings.user.uid == 0 ? false : true
        // const res = await sessionFetch
        const session = !LOCAL_ ? userLogged : responseLocal.logged
        console.log('var session', session)
        if (session) {
            console.log('-- SESSION --', LOCAL_, JSON.parse(sessionStorage.getItem("user-estadio")).state.user.json_avatar)
            if (LOCAL_) {

                avatar.setJSON(responseLocal.user.json_avatar)
            } else {

                const userData = JSON.parse(sessionStorage.getItem("user-estadio")).state.user.json_avatar
                // const userData = useSession.getState().user.json_avatar
                avatar.setJSON(userData)
            }
            
        } else {
            avatar.setJSON(responseLocal.user.json_avatar)
        }


        // let btnStartClicked = sessionStorage.getItem('btnStartClicked') // null | "true"
        let btnStartClicked = true // null | "true"
        // console.log("btnStartClicked: ", btnStartClicked)

        // -----

        if (!btnStartClicked) window.initRubigol()

        await estadio.create()
        await avatar.createUsersAvatars()
        await collectables.addCollectable()


        //
        // Sound Init on firstClic

        if (!btnStartClicked) {
            cameraController.splashScreenState()

            setTimeout(() => {
                new VideoController().open('rubigol')

                function temp() {
                    handleUI('show', 2)
                    cameraController.panning('Estadio', 4)

                    document.querySelector('#btnStartVideoPop').removeEventListener('pointerup', temp)
                }
                document.querySelector('#btnStartVideoPop').addEventListener('pointerup', temp)
            }, 9000)

        } else {
            handleUI('show', 2)
            cameraController.panning('Estadio', 4)
        }


        if (session) {
            avatar.initModel({ destiny: 'Estadio' })
        } else {
            // avatar.initModel({gender: sessionStorage.getItem('tempGender'), destiny: 'Estadio'})
            avatar.initModel({ gender: 'Hombre', destiny: 'Estadio' })
        }

    }

    function handleUI(action, delay) {
        const elements = ['.newHeaderAL', '.layout-controls', '.ar__tadaShop_layout']

        if (delay) {
            setTimeout(() => {
                elements.forEach(el => {
                    const elem = document.querySelector(el)
                    if (elem) elem.style.opacity = action === 'hide' ? 0 : 1
                })
            }, delay * 1000);
        } else {
            elements.forEach(el => {
                const elem = document.querySelector(el)
                if (elem) elem.style.opacity = action === 'hide' ? 0 : 1
            })
        }
    }
    handleUI('hide')


    /*
    function startAguila(session) {

        // soundController.play('loop_bg', true, 0.1)

            //

        const t = gsap.timeline()
        t.to(".UI-splashScreen", {
            opacity: 0,
            scale: 1.15,
            duration: 1,
            ease: "power1.out",
            onComplete() {
                this.targets()[0].remove()
            },
        }, 0)

            //
        if(session) {
            cameraController.panning('Estadio', 5)
            avatar.initModel({destiny: 'Estadio'})

            sessionStorage.setItem('btnStartClicked', 'true')

            handleUI('show', 4)

        } else {
            const delay = 5
            if(sessionStorage.getItem('btnStartClicked') == null) {
                new PopsController().open('initialGender')
            } else {
                // handleUI('show', delay - 1 )
                console.log("6")
                cameraController.panning('Estadio', delay)
            }
            
        }
    }
    */

    function masterUpdate(delta) {
        avatar.update(delta)
        cameraController.followTarget(delta)
        estadio.update(delta)
        npc.update(delta)
        collectables.update(delta)
        gift.update(delta)
    }


    // POINTER CONTROL

    /*
    // Desktop------------------------------------------------------------------

    const pointerState = {
        moved: false, // First movement
        down: false,
        dragged: false,
        position: new THREE.Vector2(size.w / 2, 0),
        clickPos: new THREE.Vector2(size.w / 2, 0)
    }
    let rect = renderer.domElement.getBoundingClientRect()

    function onPointerDown(e) {
        switch (e.pointerType) {
            case 'mouse':
            case 'pen':
                pointerState.down = true

                pointerState.clickPos.x = ( ( e.clientX - rect.left ) / rect.width ) * 2 - 1
                pointerState.clickPos.y = - ( ( e.clientY - rect.top ) / rect.height ) * 2 + 1
                break
        }
    }
    function onPointerMovement(e) {
        switch (e.pointerType) {
            case 'mouse':
            case 'pen':
                pointerState.moved = true

                pointerState.position.x = ( ( e.clientX - rect.left ) / rect.width ) * 2 - 1
                pointerState.position.y = - ( ( e.clientY - rect.top ) / rect.height ) * 2 + 1

                if( pointerState.down ) {
                    // const tolerance = 0.025
                    // if( Math.abs( (pointerState.clickPos.x - pointerState.position.x) ) > tolerance || Math.abs( (pointerState.clickPos.y - pointerState.position.y) ) > tolerance ) {
                    //     pointerState.dragged = true
                    // }
                    pointerState.dragged = true
                }
                break
        }
    }
    function onPointerUp(e) {
        switch (e.pointerType) {
            case 'mouse':
            case 'pen':
                pointerState.down = false
                pointerState.dragged = false
                break
        }
    }

    // appContainer.addEventListener( 'pointerdown', onPointerDown, false)
    // appContainer.addEventListener( 'pointermove', onPointerMovement, false )
    // appContainer.addEventListener( 'pointerup', onPointerUp, false )

        //

    function onTouchStart(e) {
        pointerState.down = true

        pointerState.clickPos.x = ((e.touches[0].clientX - rect.left) / rect.width) * 2 - 1
        pointerState.clickPos.y = -((e.touches[0].clientY - rect.top) / rect.height) * 2 + 1
    }
    function onTouchMove(e) {
        e.preventDefault()

        pointerState.clickPos.x = ((e.changedTouches[0].clientX - rect.left) / rect.width) * 2 - 1
        pointerState.clickPos.y = -((e.changedTouches[0].clientY - rect.top) / rect.height) * 2 + 1

        if( pointerState.down ) pointerState.dragged = true
    }
    function onTouchEnd(e) {
        pointerState.down = false
        pointerState.dragged = false
    }

    // appContainer.addEventListener( 'touchstart', onTouchStart, false)
    // appContainer.addEventListener( 'touchmove', onTouchMove, false)
    // appContainer.addEventListener( 'touchend', onTouchEnd, false)
    */



    // Render ------------------------------------------------------------------

    const renderPass = new RenderPass(scene, cameraController.camera)

    const toneMappingEffect = new ToneMappingEffect({
        mode: ToneMappingMode.OPTIMIZED_CINEON,
        // adaptationRate: 0.1,
    })

    const bloomEffect = new BloomEffect({
        luminanceThreshold: 0.5,
        luminanceSmoothing: 0.2,
        mipmapBlur: true,
        intensity: 1,
        radius: 0.6,
    })

    const smaaEffect = new SMAAEffect()

    const ePass = new EffectPass(
        cameraController.camera,
        // bloomEffect,
        // toneMappingEffect,
        smaaEffect,
    )

    composer = new EffectComposer(renderer, {
        // frameBufferType: THREE.HalfFloatType,
    })
    composer.addPass(renderPass)
    composer.addPass(ePass)

    // ---------------------------------------------------------------------------

    function onWindowResize() {
        if (!isM) size = getRealSize(appContainer)

        //* Used for pointerControl
        // rect = renderer.domElement.getBoundingClientRect()

        cameraController.camera.aspect = size.w / size.h
        cameraController.camera.updateProjectionMatrix()
        composer.setSize(size.w, size.h)
    }
    window.addEventListener('resize', onWindowResize, false)

    window.addEventListener('contextmenu', (e) => e.preventDefault())

    // ---------------------------------------------------------------------------

    function animate() {
        requestAnimationFrame(animate)

        if (stats) stats.update()
        if (!loadControl.finish) realLoader(clock, initAguila, '_estadio')

        //
        const delta = clock.getDelta()
        const deltaReal = 1 - Math.pow(0.06, delta)

        // Three -----
        if (loadControl.finish) masterUpdate(delta)
        composer.render(delta)

        // Cannon -----
        world.step(1 / 60, deltaReal)
        // world.fixedStep(1 / 120)
        if (cannonDebug) cannonDebugger.update()

    }
    animate()

}

export { init }